import {
  DeleteAttendeeCommand,
  DeleteAttendeeCommandOutput,
} from "@aws-sdk/client-chime-sdk-meetings";
import { getChimeClient } from "./get-chime-client";
import ToasterWithMessage from "../../components/toaster";

const { error: errorToast } = ToasterWithMessage();

export const deleteChimeAttendee = async (
  MeetingId: string,
  AttendeeId: string
): Promise<DeleteAttendeeCommandOutput | undefined> => {
  console.log(`[Log] Deleting attendee ${AttendeeId} of meeting ${MeetingId}`);

  try {
    const chimeClient = await getChimeClient();

    const deleteAttendeeInput = {
      MeetingId,
      AttendeeId,
    };

    const deleteAttendeeCommand = new DeleteAttendeeCommand(deleteAttendeeInput);

    const response = await chimeClient.send(deleteAttendeeCommand);
    return response;
  } catch (error: any) {
    if(error?.message?.includes('Meeting') && error?.message?.includes('not found')) {
      errorToast("Meeting not found");
    }else{
      errorToast(error.message);
    }
    console.error("[Log] Failed to delete attendee:", error.message || error);
  }
};
